import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { getStorefrontRoute } from '../../utils/urls';
import { useRouteOfferingType } from '../../common/hooks/useRouteOfferingType';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NotFoundError() {
  const offeringType = useRouteOfferingType();
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "notFound",
    title: unescapedText('marketplace-assets-ui.error.notFound.title'),
    children: /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(UIRouterNavButton, {
        exact: true,
        to: getStorefrontRoute(offeringType),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.error.notFound.button"
        })
      })
    })
  });
}